import React from 'react'
import routes from '../config/settings/routes'
import NavbarContainer from '../containers/Navbar/Navbar.container'
import ManagementSectionContainer from '../containers/ManagementMenu/ManagementMenu.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import ProtectBySession from '../components/Security/ProtectBySession'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import NotFoundPage from './NotFound'
import CesiumV2 from '../containers/CesiumMap/CesiumMap'

/**
 * The Cesium Map Page.
 */
const CesiumMap = () => {
  const title = 'Mapa 3D'

  // Rule for feature access
  const cesiumFeatureRule = features => features['com.cosmos/cesium']

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <ProtectByFeatures rule={cesiumFeatureRule} fallback={() => <NotFoundPage />}>
        <BrandLayout
          navbar={<NavbarContainer />}
          header={<Heading title={title} tooltipContent="Vista para visualizar puntos utilizando Cesium." />}
          sidebar={<ManagementSectionContainer current={routes.cesium} />}
          fullSection
        >
          <CesiumV2 />
        </BrandLayout>
      </ProtectByFeatures>
    </ProtectBySession>
  )
}

export default CesiumMap
